// extracted by mini-css-extract-plugin
module.exports = {"form":"VoucherForm_form__0TVHk","input":"VoucherForm_input__UQH5Q","submit":"VoucherForm_submit__YzzdL"};